<template>
  <div class="issues-app-main-header">
    <div class="burger burger_active issues-app-main-header__burger" @click="showListSidebar"
         data-action="issues-show-list-sidebar"
         v-if="showListSidebarButton"
    >
      <span/>
      <span/>
      <span/>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="isLoading" class="issues-app-main-header__user-info issues-app-main-header-user-info"
           key="user-info-loading">
        <div style="width: 50px; height: 50px; border-radius: 50%;"
             class="issues-app-main-header-user-info__avatar skeleton"/>
        <div class="issues-app-main-header-user-info__text" style="width: 100%">
          <div class="issues-app-main-header-user-info__username skeleton" style="width: 40%; height: 14px"/>
          <div class="issues-app-main-header-user-info__address skeleton" style="width: 60%; height: 12px"/>
        </div>
      </div>
      <div v-else-if="selectedTask.id" class="issues-app-main-header__user-info issues-app-main-header-user-info"
           key="user-info">
        <app-avatar :name="userName" :img="userAvatar" size="50px" class="issues-app-main-header-user-info__avatar"/>
        <div class="issues-app-main-header-user-info__text">
          <div class="issues-app-main-header-user-info__username">
            {{revertName ? apartAddress : userName}}
            <span
                    v-if="this.selectedTask.apart && this.$acl.check('isEmployee')"
                    :style="{color: `rgba(var(--app-${Number(balance) < 0 ? 'danger' : 'success'}),1)`}"
            >
              <span class="client-header-apart-info__balance-text">
                (
                <span class="client-header-apart-info__balance-text--mobile-hidden">Баланс:</span>
                {{balance | money}}
                )
              </span>
            </span>
          </div>
          <div class="issues-app-main-header-user-info__address">
            {{revertName ? userName : apartAddress}}
          </div>
        </div>
      </div>
    </transition>

    <div class="issues-app-main-header__info-button link-icon"
         @click="showInfoSidebar"
         data-action="issues-show-info-sidebar"
         v-if="showInfoSidebarButton">
      <app-icon name="InfoIcon"/>
    </div>
  </div>
</template>

<script>
  import generateFullAddress from "@/functions/generateFullAddress";

  export default {
    name: "IssuesMainHeader",
    props: {
      selectedTask: {
        default() {
          return {};
        }
      },
      isLoading: {
        default: false,
        type: Boolean
      },
      revertName: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        showListSidebarButton: false,
        showInfoSidebarButton: false,
      }
    },
    computed: {
      userAvatar() {
        return this.$options.filters.filePath(this.selectedTask.owner ? this.selectedTask.owner.avatar : 'avatars/default_avatar.png');
      },
      userName() {
        return this.selectedTask.owner ? this.selectedTask.owner.name : 'unknown';
      },
      apartAddress() {
        return generateFullAddress(this.selectedTask.apart, this.selectedTask.building);
      },
      balance() {
        return this.selectedTask.apart.balance;
      },
      windowWidth() {
        return this.$store.getters['windowWidth'];
      }
    },
    methods: {
      showListSidebar() {
        const sidebarClass = 'issues-app-list-sidebar_hidden';
        const activeSidebarClass = 'issues-app-list-sidebar_hidden-active';

        const filtersSidebar = document.querySelector(`.${sidebarClass}`);

        if (filtersSidebar) {
          if (!filtersSidebar.classList.contains(activeSidebarClass)) {
            filtersSidebar.classList.add(activeSidebarClass)
          }
        }
      },
      closeListSidebar() {
        const activeSidebarClass = 'issues-app-list-sidebar_hidden-active';

        const listSidebar = document.querySelector(`.${activeSidebarClass}`);

        if (listSidebar) {
          listSidebar.classList.remove(activeSidebarClass);
        }

      },
      showInfoSidebar() {
        this.closeListSidebar();

        const sidebarClass = 'issues-app-info-sidebar_hidden';
        const activeSidebarClass = 'issues-app-info-sidebar_hidden-active';

        const filtersSidebar = document.querySelector(`.${sidebarClass}`);

        if (filtersSidebar) {
          if (!filtersSidebar.classList.contains(activeSidebarClass)) {
            filtersSidebar.classList.add(activeSidebarClass)
          }
        }
      },
      updateShowListSidebarButton() {
        let issueApp = document.querySelector('.issues-app');
        let filtersSidebar = issueApp.querySelector('.issues-app-list-sidebar_hidden');
        this.showListSidebarButton = !!filtersSidebar;
      },
      updateShowInfoSidebarButton() {
        let issueApp = document.querySelector('.issues-app');
        let filtersSidebar = issueApp.querySelector('.issues-app-info-sidebar_hidden');
        this.showInfoSidebarButton = !!filtersSidebar;
      },
      updateShowButtons() {
        this.updateShowListSidebarButton();
        this.updateShowInfoSidebarButton();
      }
    },
    mounted() {
      setTimeout(() => {
        this.updateShowButtons();
      }, 0);
    },
    watch: {
      windowWidth() {
        setTimeout(() => {
          this.updateShowButtons();
        }, 0);
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/scss/redesign/issues/variables";

  .issues-app-main-header {
    flex-shrink: 0;
    border-bottom: 1px solid $border-color;
    padding: 15px;
    display: flex;
    align-items: center;
    min-height: 70px;
    position: relative;
    padding-right: 64px;

    &__burger {
      margin-right: 15px;
    }

    &__info-button {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .issues-app-main-header-user-info {
    display: flex;
    align-items: center;
    flex: 1;

    &__avatar {
      margin-right: 15px;
      flex-shrink: 0;

      @media (max-width: 768px) {
        display: none;
      }
    }

    &__address {
      font-size: 0.85rem;
    }

    &__username {
      font-size: 1.15rem;
      margin-bottom: 5px;
      font-weight: 600;
    }

    &__text {
      line-height: 1.2;
    }
  }
</style>
